
const SnsMini = require("./SnsMini")

let sns = xClass("snsHonorQuickgame", SnsMini)

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'honor_video_ad';
    //mini.initAd("30098064");
}

/**
 * 转译广告位
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    return '1871145337103843328';
}

sns.prototype.getOpenKey = function (cb) {
    var self = this
    console.log("[####] snHonorQuickgame getOpenKey start...");
    mini.login({
        success:(res)=>{
            console.log("[####] snHonorQuickgame login data1:",JSON.stringify(res))
            //token = res.data.token
            META.tokenid = res.token
            if (cb){
                cb({   
                    //pkgName:"com.happyelements.clover.h5.honor.minigame",
                    token:res.openId
                })
            }
        },
        fail:(res)=>{
            console.log("[####] snHonorQuickgame login failed")
        },
        complete:(res)=>{
            console.log("[####] snHonorQuickgame login complete")
        }
    })


    return
}

sns.prototype.onLoginFinish = function(openid, sessionid){
    console.log("[####]honor login finish openid:"+openid+" sess:"+sessionid)
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        //cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        //cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]honor login finish failed no openid or sessionid")
    }

}
sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}


sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    
}

sns.prototype.popBack = function () {
    mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

sns.prototype.drawDataToImg = function (bgpath, info, callback) {

}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}

module.exports = sns